module.exports = __webpack_public_path__ + "img/logo.ea536af8.png";